// extracted by mini-css-extract-plugin
export default {"header":"style_header__KrcdF","title":"style_title__MAZQ0","deleteButton":"style_deleteButton__Z4GSz"};